/*
 * Short names for the maternity hospitals, so the message log can show who sent a message without
 * the row growing wide enough to push the view action off the screen (Darren, Eleanor).
 *
 * Darren's test for what is safe to shorten: "everyone would know what NMH is, and then for Coombe
 * or Rotunda space won't be an issue". So this is a curated map of the facilities MN-CMS actually
 * names, not a general abbreviator — initialising an unknown string would invent acronyms nobody
 * uses and hide which hospital a message came from, which is worse than a wide column.
 *
 * Anything not listed is returned unchanged and left to the cell to truncate, with the full name
 * on hover either way.
 */
const SHORT_NAMES = [
  [/national\s+maternity/i, "NMH"],
  [/coombe/i, "Coombe"],
  [/rotunda/i, "Rotunda"],
  [/cork\s+university\s+maternity/i, "CUMH"],
  [/university\s+hospital\s+kerry/i, "UHK"],
  [/\bUL\s+hospitals/i, "UL"],
];

export const abbreviateHospitalName = (name) => {
  const full = String(name ?? "").trim();

  if (!full) return "";

  const match = SHORT_NAMES.find(([pattern]) => pattern.test(full));

  return match ? match[1] : full;
};
